import { storage } from '../firebase';
import { ref, uploadString, getDownloadURL } from 'firebase/storage';

// 아직 업로드하지 않은 새 사진인가(브라우저에서 만든 data URL)
export const isDataUrl = (src) => typeof src === 'string' && src.startsWith('data:');

/**
 * 리콜 현장 사진 1장을 Storage 에 올리고 내려받기 주소를 돌려준다.
 *
 * 왜 Storage 를 쓰는가: 사진을 글자(base64)로 바꿔 Firestore 문서에 직접 넣으면
 * 문서 1개당 1MB 한도를 금방 넘겨 저장 자체가 실패한다(차량 2~3대분이면 초과).
 * 문서에는 짧은 주소만 남기고 실제 파일은 Storage 에 둔다.
 */
export const uploadRecallPhoto = async (execId, carNumber, dataUrl) => {
  const safeCar = String(carNumber || 'unknown').replace(/[^0-9a-zA-Z가-힣]/g, '') || 'unknown';
  const fileName = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}.jpg`;
  const fileRef = ref(storage, `recall/${execId}/${safeCar}/${fileName}`);
  await uploadString(fileRef, dataUrl, 'data_url');
  return await getDownloadURL(fileRef);
};

/**
 * PDF 보고서에 넣을 수 있는 형태로 바꾼다.
 *
 * PDF 생성기는 이미지의 실제 바이트가 필요한데, Storage 주소를 그대로 넣으면
 * 브라우저 보안(CORS) 때문에 못 읽어올 수 있다. 그래서 먼저 내려받아 이미지로 바꿔 넘긴다.
 * 실패하면 null 을 돌려주고, 호출부는 그 사진만 건너뛴다(보고서 자체는 정상 생성).
 */
export const toEmbeddableImage = async (src) => {
  if (!src) return null;
  if (isDataUrl(src)) return src;              // 예전에 문서에 저장된 사진은 그대로 사용
  try {
    const res = await fetch(src);
    if (!res.ok) return null;
    const blob = await res.blob();
    return await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    console.error('사진을 보고서에 넣지 못했습니다(파일 주소 접근 실패):', e);
    return null;
  }
};
